import React from 'react';
import { connect } from 'react-redux'
import RoleTemplatesTable from '../common/RoleTemplatesTable';

import CONFIG from '../../config';
import SearchFilter from '../common/SearchFilter';
import pushMessage from '../common/PushMessage';
import { updateRoleTemplateSupport, toggleIsFetchingSupportGuides, fetchAllSupportGuides } from '../../actions';

class RoleTemplatesSupport extends React.Component {

    state = {
        selectAllDisabled: false
    }

    getFilterDropDown = (filterProps, dataIndex) => {
        const { setSelectedKeys, selectedKeys, confirm, clearFilters } = filterProps;
        return (
            <SearchFilter
                dataIndex={dataIndex}
                searchString={selectedKeys[0]}
                setSearchString={setSelectedKeys}
                confirm={confirm}
                handleClear={this.handleClear}
                handleSearch={this.handleFilter}
                clearFilters={clearFilters}
            />
        )
    }

    columnFilters = {
        filterDropdown: (filterProps) => this.getFilterDropDown(filterProps, "title"),
        sorter: (a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
        onFilter: (value, record) =>
            record.title
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
    }

    handleFilter = (title, confirm) => {
        title = title?.trim();
        if (!title && !this.state.selectAllDisabled) {
            pushMessage(CONFIG.messageType.warning, "Please enter a search string")
            return;
        }
        else confirm()
    }

    handleClear = (clearFilters) => {
        clearFilters();
    }

    handleChange = (_, filters) => {
        const selectAllDisabled = Object.values(filters).filter(value => value.length !== 0)?.length ? true : false;
        this.setState({ selectAllDisabled });
    }

    componentDidMount() {
        this.props.toggleIsFetchingSupportGuides();
        this.props.fetchAllSupportGuides();
    }

    render() {
        const { supportGuides, assignedSupport, allSupportAdminAccess, isFetching, updateRoleTemplateSupport } = this.props;
        const { selectAllDisabled } = this.state;
        const extraColumn = {
            title: "Type",
            dataIndex: "guideType",
            key: "guideType",
            width: '30%',
            filters: CONFIG.filterDataSet.guideTypes,
            sorter: (a, b) => a.guideType.localeCompare(b.guideType),
            onFilter: (value, record) => record.guideType === value,
            render: (type) => {
                return (
                    type[0].toUpperCase() + type.slice(1).toLowerCase().replace("_", " ")
                )
            }
        };

        return (
            <RoleTemplatesTable
                dataKey="supportGuide"
                hideColumns={['user']}
                marginTop={true}
                extraColumns={[extraColumn]}
                bordered={true}
                data={supportGuides || []}
                selectAllDisabled={selectAllDisabled}
                columnFilters={this.columnFilters}
                onChange={this.handleChange}
                pagination={{
                    pageSize: CONFIG.shortPageSize + 1,
                }}
                isFetching={isFetching}
                assignedData={assignedSupport}
                allAdminAccess={allSupportAdminAccess}
                updateRoleTemplateData={updateRoleTemplateSupport}
            />
        );

    }

}
const mapStateToProps = ({ support, roleTemplate }) => {
    return {
        supportGuides: support.adminSupportGuides,
        assignedSupport: roleTemplate.supportGuides,
        allSupportAdminAccess: roleTemplate.allSupportAdminAccess,
        isFetching: support.isFetching
    }
}

export default connect(mapStateToProps, { updateRoleTemplateSupport, toggleIsFetchingSupportGuides, fetchAllSupportGuides })(RoleTemplatesSupport);